<template>
  <div>
    <tci-about-us :title="$t('corporate_vision.title')">
      <v-row no-gutters class="mb-4" >
        <v-spacer></v-spacer>
        <v-col>
          <v-card class="mt-0" width="700" flat tile color="transparent">
            <v-card-title class="py-0">{{ $t('corporate_vision.target.title') }}</v-card-title>
            <v-card-title class="py-0 body-1" v-html="$t('corporate_vision.target.content')"></v-card-title>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row no-gutters class="pt-8" >
        <v-spacer></v-spacer>
        <v-col>
          <v-card class="mt-0" width="700" flat tile color="transparent">
            <v-card-title class="py-0">{{ $t('corporate_vision.promise.title') }}</v-card-title>
            <v-list v-for="item in $t('corporate_vision.promise.contents')" :key="item.subtitle" class="pl-4" two-line>
              <v-list-item-content>
                <v-list-item-title>{{ item.subtitle }}</v-list-item-title>
                <v-list-item-subtitle class="text-wrap" v-for="subItem in item.subContents" :key="subItem">
                  {{ subItem }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row no-gutters class="pt-8" >
        <v-spacer></v-spacer>
        <v-col>
          <v-card width="700" flat tile color="transparent">
            <v-card-title class="py-0">{{ $t('corporate_vision.faith.title') }}</v-card-title>
            <v-card-title class="py-0">{{ $t('corporate_vision.faith.subtitle') }}</v-card-title>
            <v-card-title class="py-0 body-1" v-html="$t('corporate_vision.faith.content')"></v-card-title>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
    name: 'CompanyVision',
    components: {
    "tci-about-us": TciAboutUs,
    "tci-contact-footer": TciContactFooter
  }
}
</script>
